module.exports = __webpack_public_path__ + "static/media/Warning.be374d31.svg";